export default __webpack_public_path__ + "static/8522-a8b96d654bf6831d176a0d7f0abbc553.jpg";